import { Navigate, Route, Routes } from 'react-router-dom';
import {
  Login,
  ResetPassword,
  ResetPasswordChange,
  ResetPasswordCheckEmail,
  TwoFactorAuth,
} from './pages/jwt';
import { AuthBrandedLayout } from '@/layouts/auth-branded';
import { CheckEmail } from '@/auth/pages/jwt';
import { AuthRoutes } from './AuthRoutes';
import { AccountVerified } from './pages/jwt/AccountVerified';

const AuthPage = () => (
  <Routes>
    <Route element={<AuthRoutes />}>
      <Route element={<AuthBrandedLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/2fa" element={<TwoFactorAuth />} />
        <Route path="/account-verified" element={<AccountVerified />} />
        <Route path="/check-email" element={<CheckEmail />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/reset-password/check-email"
          element={<ResetPasswordCheckEmail />}
        />
        <Route
          path="/reset-password/:token"
          element={<ResetPasswordChange />}
        />
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Route>
    </Route>
  </Routes>
);

export { AuthPage };
